export const CORRECT_CLASS = 'correct-option';
export const HIDE_CLASS = 'hide-option';
export const INACTIVE_CLASS = 'box-inactive';